module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-progress__wrapper"
  }, [_c('div', {
    staticClass: "step-progress__wrapper-before",
    style: ({
      "background-color": _vm.passiveColor,
      height: _vm.lineThickness + "px"
    })
  }), _c('div', {
    staticClass: "step-progress__bar"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      staticClass: "step-progress__step",
      class: {
        "step-progress__step--active": index === _vm.currentStep,
        "step-progress__step--valid": index < _vm.currentStep
      },
      style: ({
        "--activeColor": _vm.activeColor,
        "--passiveColor": _vm.passiveColor,
        "--activeBorder": _vm.activeThickness + "px",
        "--passiveBorder": _vm.passiveThickness + "px"
      })
    }, [_c('div', {
      staticClass: "step-progress__step-icon",
      class: _vm.iconClass
    }), _c('div', {
      staticClass: "step-progress__step-label"
    }, [_vm._v(_vm._s(step))])])
  }), 0), _c('div', {
    staticClass: "step-progress__wrapper-after",
    style: ({
      transform: "scaleX(" + _vm.scaleX + ") translateY(-50%) perspective(1000px)",
      "background-color": _vm.activeColor,
      height: _vm.lineThickness + "px"
    })
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5e6e690", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5e6e690"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/step/stepProgress.pug
// module id = 1456
// module chunks = 0